import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";

const layoutCompany = {
    namespaced: true,
    state: {
        drawer: false,
        sidebarHeaders: []
    },
    mutations: {
        toggleDrawer(state) {
            state.drawer = !state.drawer;
        },
        GET_SIDEBAR_HEADERS_SUCCESS(state, response) {
            state.sidebarHeaders = response.data;
            eventBus.$emit("successGetSidebarHeaders");
        },
        GET_SIDEBAR_HEADERS_ERROR(state, error) {
            console.log(error);
        }
    },
    actions: {
        TOGGLE_DRAWER({commit}) {
            commit("toggleDrawer");
        },
        getSidebarHeaders({ dispatch}, payload) {
            var promise = sendRequest("post", config.baseURLApi+"/language/getSidebarHeaders", {}, payload.creds);
            promise.then(function(result) {
               if(result[0] === "success") {
                   dispatch("successGetSidebarHeaders", result[1]);
               } else {
                   dispatch("errorGetSidebarHeaders", result[1]);
               }
            });
        },
        successGetSidebarHeaders: function({commit}, response) {
            commit("GET_SIDEBAR_HEADERS_SUCCESS", response);
        },
        errorGetSidebarHeaders: function({commit}, error) {
            commit("GET_SIDEBAR_HEADERS_ERROR", error);
        }
    }
}

export default layoutCompany;